module.exports = __webpack_public_path__ + "media/images/handshake-726ea8aa04dea9497cf4c93b6a7551bd.png";